import type {
  IProblemRecord,
  ISection,
  ISubnavItem,
  ITableBlock,
  ITableColumn,
  ITableUI,
} from "../../../shared/ui/data-table/model/data-table-contract";

export type {
  IProblemRecord,
  ISection,
  ISubnavItem,
  ITableBlock,
  ITableColumn,
  ITableUI,
};

export const getDocuments = (store: {
  documents: { data: IProblemRecord | null };
}) => store.documents.data;
